import React from 'react'
import PropTypes from 'prop-types'
import { ArrowLeft } from 'lucide-react'
import { cn } from '../utils/designSystem'

const AgentHeader = ({ 
  onBack, 
  icon: Icon, 
  title, 
  query, 
  iconColor = 'text-blue-500', 
  iconBgColor = 'bg-blue-500/10',
  actions = [],
  className = ''
}) => {
  return (
    <div className={cn(
      "bg-bg-secondary border-b border-border-primary sticky top-0 z-10",
      className
    )}>
      <div className="max-w-6xl mx-auto px-2 sm:px-4 py-2 sm:py-4">
        <div className="flex items-center justify-between gap-2">
          {/* Left section - Back button and title */}
          <div className="flex items-center space-x-2 sm:space-x-4 min-w-0 flex-1">
            <button
              onClick={onBack}
              className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 text-text-tertiary hover:text-text-primary transition-colors rounded-lg hover:bg-bg-tertiary flex-shrink-0"
            >
              <ArrowLeft className="w-3 h-3 sm:w-4 sm:h-4" />
              <span className="text-xs sm:text-sm font-medium hidden sm:inline">Kembali</span>
            </button>
            
            <div className="flex items-center space-x-2 sm:space-x-3 min-w-0">
              <div className={cn(
                "p-1.5 sm:p-2 rounded-lg flex-shrink-0",
                iconBgColor
              )}>
                <Icon className={cn(
                  "w-4 h-4 sm:w-6 sm:h-6",
                  iconColor
                )} />
              </div>
              
              <div className="min-w-0">
                <h1 className="text-sm sm:text-xl font-semibold text-text-primary">
                  {title}
                </h1>
                {query && (
                  <p className="text-xs sm:text-sm text-text-tertiary truncate max-w-[200px] sm:max-w-none">
                    "{query}"
                  </p>
                )}
              </div>
            </div>
          </div>
          
          {/* Right section - Action buttons */}
          {actions.length > 0 && (
            <div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
              {actions.map((action, index) => (
                <button
                  key={index}
                  onClick={action.onClick}
                  className={cn(
                    "flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm transition-colors rounded-lg",
                    action.className || "bg-bg-tertiary hover:bg-bg-quaternary text-text-secondary hover:text-text-primary"
                  )}
                  disabled={action.disabled}
                >
                  {action.icon && (
                    <action.icon className="w-3 h-3 sm:w-4 sm:h-4" />
                  )}
                  {action.label && (
                    <span className={action.hideOnMobile ? "hidden sm:inline" : ""}>
                      {action.label}
                    </span>
                  )}
                  {action.mobileLabel && (
                    <span className="sm:hidden">
                      {action.mobileLabel}
                    </span>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

AgentHeader.propTypes = {
  onBack: PropTypes.func.isRequired,
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  query: PropTypes.string,
  iconColor: PropTypes.string,
  iconBgColor: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.elementType,
    label: PropTypes.string,
    mobileLabel: PropTypes.string,
    hideOnMobile: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool
  })),
  className: PropTypes.string
}

export default AgentHeader